import { PHOTO_FACET_TYPE_LIST } from '../constants.ts';

import { type PhotoFacetType } from '../types.ts';

export const isPhotoFacetType = (param?: string): param is PhotoFacetType => {
    const photoFacetTypes: readonly string[] = PHOTO_FACET_TYPE_LIST;
    return photoFacetTypes.includes(param || '');
};
